export const getAlertEditorStyles = () => `
    :host {
        display: contents;
    }

    .form-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 0 24px;
    }

    .content {
        padding: 0.5rem 0;
    }

    .form-section {
        margin-bottom: 2rem;
    }

    .section-label {
        font-family: var(--font-mono);
        font-size: 0.7rem;
        text-transform: uppercase;
        color: var(--accent);
        margin-bottom: 1.5rem;
        display: flex;
        align-items: center;
        gap: 8px;
        letter-spacing: 0.1em;
        opacity: 0.8;
    }

    .section-label::after {
        content: "";
        flex: 1;
        height: 1px;
        background: linear-gradient(90deg, rgba(245, 158, 11, 0.2), transparent);
    }

    .destination-list {
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin-top: 1rem;
    }

    .destination-item {
        display: grid;
        grid-template-columns: 140px 1fr 40px;
        gap: 12px;
        align-items: flex-end;
        padding: 1rem;
        background: rgba(255, 255, 255, 0.02);
        border: 1px solid var(--border-sketch);
        border-radius: 8px;
    }

    .metric-preview {
        margin-top: 1.5rem;
        padding: 1.5rem;
        background: rgba(0,0,0,0.2);
        border: 1px dashed var(--border-sketch);
        border-radius: 8px;
    }

    .preview-summary {
        font-size: 0.9rem;
        color: var(--text-dim);
        line-height: 1.6;
    }

    .preview-summary b {
        color: var(--accent);
    }
`;
